// extracted by mini-css-extract-plugin
export default {"wrapper":"Homepage_wrapper__-CtZV","left":"Homepage_left__VTmOr","right":"Homepage_right__f1eRz","btn":"Homepage_btn__5cPBW"};